<template>
  <div class="flex space-x-2.5">
    <div class="flex flex-col space-y-2.5" style="max-width: 400px;">
      <div>
        <v-text-field v-model="date" :error-messages="fieldErrors.date" label="Date" type="date" dense outlined
                      hide-details="auto" />
      </div>
      <div>
        <v-text-field v-model.number="amount" :error-messages="fieldErrors.amount" label="Amount" type="number" dense
                      outlined hide-details="auto" />
      </div>
      <v-btn class="ma-0" elevation="0" color="primary" :loading="addingTransaction" @click="addTransaction">
        Add
        Amount
      </v-btn>
    </div>
    <div class="flex-1">
      <div>
        <v-btn :loading="gettingTransactions" small dense color="primary" elevation="0"
               @click="getTransactions">
          Reload
        </v-btn>
      </div>
      <v-simple-table dense>
        <thead>
          <tr>
            <th style="width: 1%; white-space: nowrap;">
&nbsp;
            </th>
            <th>Date</th>
            <th class="text-right">
              Amount
            </th>
            <th class="text-center" style="width: 1%; white-space: nowrap;">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in items" :key="item.id">
            <td class="text-center">
              {{ index + 1 }}
            </td>
            <td>{{ item.date }}</td>
            <td class="text-right">
              {{ formatAccounting(item.amount) }}
            </td>
            <td>
              <v-btn :loading="item.deleting" text dense small>
                <v-icon color="red" @click="deleteTransaction(item)">
                  mdi-delete
                </v-icon>
              </v-btn>
            </td>
          </tr>
          <tr>
            <th>Total</th>
            <td>&nbsp;</td>
            <td class="text-right">
              {{ formatAccounting(totalAmount) }}
            </td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <th>Receivables</th>
            <td>&nbsp;</td>
            <td class="text-right">
              {{ formatAccounting(receivables) }}
            </td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <th>Balance</th>
            <td>&nbsp;</td>
            <td class="text-right">
              {{ formatAccounting(balance) }}
            </td>
            <td>&nbsp;</td>
          </tr>
        </tbody>
      </v-simple-table>
    </div>
  </div>
</template>
<script>
import axios from '@/extra-functions/axios.extra'
import { mapState } from 'vuex'
import { formatAccounting, getCurrentDate, useWatchEffect } from '../../../../lib/utils'
const inputVars = () => ({
  date: getCurrentDate(),
  amount: null,
})

const [watchEffect, clearWatchEffect] = useWatchEffect()

export default {
  name: 'CreateTransferTransactionInventory',
  props: {
    storeTransferId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      ...inputVars(),
      fieldErrors: {},
      addingTransaction: false,
      items: [],
      totalAmount: 0,
      balance: 0,
      receivables: 0,
      gettingTransactions: false,
    }
  },
  created() {
    watchEffect((onCleanup) => {
      const controller = new AbortController()
      onCleanup(() => {
        controller.abort()
      })
      this.getTransactions(controller)
    }, 'created')
  },
  destroyed() {
    clearWatchEffect()
  },
  computed: {
    ...mapState({
      authToken: state => state.auth?.token,
    }),
  },
  watch: {
    storeTransferId() {
      watchEffect((onCleanup) => {
        const controller = new AbortController()
        onCleanup(() => {
          controller.abort()
        })
        this.getTransactions(controller)
      }, 'storeTransferId')
    },
  },
  methods: {
    async getTransactions(controller) {
      try {
        this.gettingTransactions = true
        const { data } = await axios(this.authToken).get(`/store-transfers/${this.storeTransferId}/transactions`, { signal: controller?.signal })
        this.items = data.transactions
        this.totalAmount = data.paid
        this.balance = data.balance
        this.receivables = data.receivables
      } catch (e) {
        console.error(e.message)
        this.$alertSwalError('oops something went wrong')
      } finally {
        this.gettingTransactions = false
      }
    },
    async addTransaction() {
      try {
        if (this.addingTransaction) return
        this.fieldErrors = {}
        this.addingTransaction = true
        const data = Object.keys(inputVars()).reduce((prev, next) => {
          prev[next] = this[next]
          return prev
        }, {})
        const result = await axios(this.authToken).post(`/store-transfers/${this.storeTransferId}/transactions`, data)
        this.getTransactions()
        this.$alertSwalSuccess()
        this.$emit('store-success')
      } catch (e) {
        if (e.response?.status === 422) {
          this.fieldErrors = e.response?.data?.errors || {}
          return
        }
        console.error(e.message)
        this.$alertSwalError('oops something went wrong')
      } finally {
        this.addingTransaction = false
      }
    },
    async deleteTransaction(item) {
      try {
        const confirm = await this.$confirm('hello')
        if (!confirm) return
        item.deleting = true
        this.items = [...this.items]
        const result = await axios(this.authToken).delete(`/store-transfers/${this.storeTransferId}/transactions/${item.id}`)
        this.items = this.items.filter(current => current.id !== item.id)
        this.$emit('delete-success')
      } catch (e) {
        console.error(e.message)
        this.$alertSwalError('oops something went wrong')
        item.deleting = false
        this.items = [...this.items]
      }
    },
    formatAccounting(number) {
      return formatAccounting(number)
    },
  },
}
</script>
